export const formatDateTime = (date, time) => {
    if (!date) return '♾️';
    const dateStr = new Date(date).toLocaleDateString();
    return time ? `${dateStr} ${time}` : dateStr;
};